import { useEffect, useState } from "react";
import DashboardLayout from "../../../Layouts/Layoutcontainers";
import { Card, Zoom, Tooltip, IconButton } from "@mui/material";
import { Edit, Error } from "@mui/icons-material";
import BTBox from "../../../components/BTBox";
import BTButton from "../../../components/BTButton";
import EnhancedTable from "../../../components/BTTable";
import AddSize from "./AddSize";
import { useLoading, useNotification } from "../../../context";
import { get_sizes } from "../../../store/functions";
import { useSelector } from "react-redux";
const Sizes = () => {
  const sizes = useSelector((state) => state?.lab?.sizes);
  const [open, setOpen] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const CardHeader = () => {
    return (
      <Card sx={{ mb: 1 }}>
        <BTBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          pt={2}
          pb={2}
          px={3}
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BTButton
            variant="gradient"
            size="small"
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Add size
          </BTButton>
        </BTBox>
      </Card>
    );
  };
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection={"row"} gap={1}>
        <Tooltip title="Edit" TransitionComponent={Zoom}>
          <Edit
            color="warning"
            sx={{ cursor: "pointer", fontSize: "18px" }}
            onClick={async () => {
              showLoading();
              await new Promise((resolve) => setTimeout(resolve, 1000));
              hideLoading();
              setOpen({
                actionType: 2,
                show: true,
                value: sizes?.data,
              });
            }}
          />
        </Tooltip>
      </BTBox>
    );
  };
  const getSizes = async () => {
    showLoading();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await get_sizes();
    if (!response?.status) {
      addNotification({
        message: response?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
    hideLoading();
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "0.1rem",
      numeric: false,
      sortable: true,
    },
    {
      id: "size_from",
      name: "From Size",
      cell: (row) => Number(row?.size_from).toFixed(2),
      sortable: true,
      numeric: false,
      width: "50px",
    },
    {
      id: "size_to",
      name: "To Size",
      numeric: false,
      selector: (row) => Number(row?.size_to).toFixed(2),
      sortable: false,
      width: "50px",
    },
    {
      id: "size_desc",
      name: "Description",
      selector: (row) => row?.size_desc,
      numeric: false,
      sortable: true,
      width: "150px",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row) => <Actions row={row} />,
      width: "80px",
    },
  ];

  useEffect(() => {
    !sizes?.is_fetch && getSizes();
  }, []);

  return (
    <DashboardLayout>
      <CardHeader />
      <EnhancedTable
        tableHeader={true}
        rows={sizes?.data?.filter(({ size_deleted }) => !size_deleted)}
        columns={columns}
        title="Sizes"
        defaultSort="size_code"
        pagination={true}
      />
      {Boolean(open) && <AddSize open={open} setOpen={setOpen} />}
    </DashboardLayout>
  );
};
export default Sizes;
